@if (data) {
  <app-sankey [data]="data"></app-sankey>
}
